import { Injectable } from '@angular/core';
import { CacheService } from 'projects/common/src/app/services';
import { ISession } from 'projects/common/src/app/interfaces/authentication';
import { HubConnection } from '@aspnet/signalr';
import * as signalR from '@aspnet/signalr';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HubConnectionService {
  constructor(private cache: CacheService, private http: HttpClient) {}

  /**
   * Function to get token
   */
  public getToken(): string {
    const user = this.cache.local('session') as ISession;
    return user.token;
  }

  /**
   * Function to start the connection with server
   */
  public startConnection(hubConnection: HubConnection, notification: any): void {
    hubConnection
      .start()
      .then(() => {
        // console.log('SignalR Hub connection started');
        this.subscribeToServerEvents(hubConnection, notification);
      })
      .catch((error) => {
        this.restartConnection(error, hubConnection, notification);
      });

    hubConnection.onclose((error) => {
      // console.log('SignalR hub connection closed.');
      this.stopHubAndUnsubscribeToServerEvents(hubConnection);
      this.restartConnection(error, hubConnection, notification);
    });
  }

  /**
   * Function to restart the connection
   * @param err Error
   */
  private restartConnection(error: Error, hubConnection?: HubConnection, notification?: any): void {
    // console.log(`Error ${error}`);
    // console.log('Retrying connection to SignalR Hub ...');
    setTimeout(() => this.startConnection(hubConnection, notification), 10000);
  }

  /**
   * Subscribe to server events
   */
  private subscribeToServerEvents(hubConnection: HubConnection, notification: any): void {
    hubConnection.on('MessageNotification', (data: any) => {
      notification.emit(`MessageNotification:${data}`);
    });

    hubConnection.on('PublishMessageAck', (data: any) => {
      notification.emit(`MessageNotification - Ack :${data}`);
    });
  }

  /**
   * Unsubscribe to server events
   */
  private stopHubAndUnsubscribeToServerEvents(hubConnection: HubConnection): void {
    hubConnection.off('MessageNotification');
    hubConnection.off('PublishMessageAck');
    hubConnection.stop().then(() => console.log('Hub connection stopped'));
  }

  /**
   * Function to stop the connection
   */
  public stopConnection(hubConnection: HubConnection): Promise<void> {
    if (hubConnection && hubConnection.state !== signalR.HubConnectionState.Disconnected) {
      return hubConnection.stop().then(() => {
        hubConnection = null;
      });
    }
    return Promise.resolve(); // return a resolved promise if connection is already stopped
  }

  /**
   * Function to create request
   * @param route Route
   * @param body body request
   */
  public create(route: string, body: any): Promise<any> {
    return this.http.post(this.createCompleteRoute(route, environment.securityBasePath), body, this.generateHeaders()).toPromise();
  }

  /**
   * Function to complete route
   * @param route Route
   * @param envAddress Environment address
   */
  public createCompleteRoute(route: string, envAddress: string): string {
    return `${envAddress}/${route}`;
  }

  /**
   * Function to generate headers
   */
  public generateHeaders(): any {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
  }
}
